import { MinimalUser } from '@/queries/community-feed/types';
import { trackMP } from '@/shared/mp';

import AnimalIcon from '../../AnimalIcon';
import CardLink from './CardLink';

const CardProfileImage = ({ user }: { user?: MinimalUser }) => {
  return user?.profile ? (
    <CardLink
      href={`/u/${user.username}`}
      onClick={() => {
        trackMP('community-feed-clicked', {
          content: 'user-profile-image',
        });
      }}
    >
      <AnimalIcon
        animalIcon={user.profile.animalIcon}
        color={user.profile.color}
        gradient={user.profile.gradient}
        width={40}
      />
    </CardLink>
  ) : (
    <AnimalIcon animalIcon="animal4" color="#FF8A00" width={40} />
  );
};

export default CardProfileImage;
